<template>
    <div>
        <div class="row">
            <div :class="tileClass" class="mb-3">
                <clickable-tile :to="{ name: 'admin.reports.coach-new' }">
                    <template slot="icon"><i class="fa fa-lg fa-pie-chart"></i></template>
                    <h2>{{ uLang('app.results') }}</h2>
                </clickable-tile>
            </div>
            <div :class="tileClass" class="mb-3">
                <clickable-tile :to="{ name: 'admin.reports.coach-capacity' }">
                    <template slot="icon"><i class="fa fa-lg fa-pie-chart"></i></template>
                    <h2>{{ uLang('app.results_coach_capacity') }}</h2>
                </clickable-tile>
            </div>
            <div :class="tileClass" class="mb-3">
                <clickable-tile :to="{ name: 'admin.reports.bow-export' }">
                    <template slot="icon"><i class="fa fa-lg fa-download"></i></template>
                    <h2>{{ uLang('app.bow_export') }}</h2>
                </clickable-tile>
            </div>
            <div :class="tileClass" class="mb-3">
                <clickable-tile :to="{ name: 'admin.reports.coach-feedback' }">
                    <template slot="icon"><i class="fa fa-lg fa-comments"></i></template>
                    <h2>{{ uLang('app.coach_feedback') }}</h2>
                </clickable-tile>
            </div>
            <div v-if="!isCoach" :class="tileClass" class="mb-3">
                <clickable-tile :to="{ name: 'admin.reports.enrolments-timelogs' }">
                    <template slot="icon"><i class="fa fa-lg fa-clock-o"></i></template>
                    <h2>{{ uLang('app.Enrolment TimeLogs') }}</h2>
                </clickable-tile>
            </div>
        </div>
    </div>
</template>

<script>
    import { ClickableTile } from '~/components/helpers'

    export default {
        name: 'ReportsIndex',

        components: {
            ClickableTile
        },

        computed: {
            isCoach() {
                return this.$hasType('coach');
            },
            tileClass() {
                return this.isCoach ? 'col-lg-3' : 'col-lg-4';
            },
        },
    }
</script>

<style lang="css" scoped>

</style>
